import { __assign } from "tslib";
import React, { useRef, useMemo, useState, useEffect } from "react";
import { TextField, makeStyles } from "@material-ui/core";
import MaterailAutocomplete from "@material-ui/lab/Autocomplete";
var useStyles = makeStyles(function () {
  return {
    textField: {
      cursor: "pointer",
      "&>div": {
        paddingTop: "2px !important",
        paddingBottom: "2px !important"
      },
      "& fieldset": {
        borderRadius: 16,
        borderWidth: "1px !important"
      }
    }
  };
});

var Autocomplete = function Autocomplete(props) {
  var _a = props.options,
      options = _a === void 0 ? [] : _a,
      inputValue = props.value,
      size = props.size,
      disableCircle = props.disableCircle,
      _b = props.placeholder,
      placeholder = _b === void 0 ? "" : _b,
      _c = props.label,
      label = _c === void 0 ? "" : _c,
      _d = props.fullWidth,
      fullWidth = _d === void 0 ? true : _d,
      _e = props.freeSolo,
      freeSolo = _e === void 0 ? false : _e,
      _f = props.variant,
      variant = _f === void 0 ? "outlined" : _f,
      _g = props.disabled,
      disabled = _g === void 0 ? false : _g,
      disableClearable = props.disableClearable,
      startAdornment = props.startAdornment,
      popupIcon = props.popupIcon,
      className = props.className,
      classes = props.classes,
      style = props.style,
      renderOption = props.renderOption,
      request = props.request,
      onChange = props.onChange;
  var timer = useRef(0);
  var styles = useStyles();

  var _h = useState(false),
      open = _h[0],
      setOpen = _h[1]; // const [value, setValue] = useControlled({
  //   controlled: inputValue,
  //   default: "",
  // });


  var _j = useState(inputValue),
      value = _j[0],
      setValue = _j[1];

  useEffect(function () {
    if (inputValue !== value) {
      setValue(inputValue);
    }
  }, [inputValue]);

  function handleChange(event, option) {
    setValue(typeof option === "object" && option !== null ? option.value : option);
    onChange && onChange(typeof option === "object" && option !== null ? option.value : option);
  }

  var optionValue = useMemo(function () {
    return options.find(function (item) {
      return item.value === value;
    }) || null;
  }, [value, options]);

  function handleInputChange(event, inputValue) {
    if (request) {
      if (timer.current) {
        clearTimeout(timer.current);
      } // if backspace input and value existed, clear it


      if (optionValue && optionValue.label && typeof inputValue === "string" && optionValue.label.length - inputValue.length === 1) {
        handleChange(null, null);
      } else {
        timer.current = window.setTimeout(function () {
          request(inputValue);
        }, 300);
      }
    }
  }

  return React.createElement(MaterailAutocomplete, {
    fullWidth: fullWidth,
    size: size,
    clearOnBlur: true,
    options: options,
    style: style,
    open: open,
    onOpen: function onOpen(e) {
      if (e.type !== "mousedown" || e.target.value !== "") {
        setOpen(true);
      }
    },
    onClose: function onClose() {
      setOpen(false);
    },
    classes: classes,
    className: className,
    disableClearable: disableClearable,
    freeSolo: freeSolo,
    value: optionValue,
    popupIcon: popupIcon,
    disabled: disabled,
    onInputChange: handleInputChange,
    onChange: handleChange,
    renderOption: renderOption,
    getOptionLabel: function getOptionLabel(option) {
      return option.label === undefined ? option : option.label;
    },
    renderInput: function renderInput(params) {
      return React.createElement(TextField, __assign({}, params, {
        label: label,
        placeholder: placeholder,
        style: {
          background: "white",
          fontSize: 14
        },
        className: disableCircle ? "" : styles.textField,
        InputProps: __assign(__assign({}, params.InputProps), {
          startAdornment: startAdornment
        }),
        variant: variant
      }));
    }
  });
};

export default Autocomplete;